import httpService from "./httpService";
interface cancelMem {
    user_id: string | number,
    membership_id: string | number
}
interface codeMem {
    user_id: string | number,
    company_code: string | number
}
export const getMembershipPlan = () => {
    return httpService.get("membership/")
}

export const onBoardingFamily = (data: any) => {
    return httpService.post("onboarding/family", data)
}

export const confirmMembership = (data: any) => {
    return httpService.post("membership/confirm", data)
}
export const cancelMembershipApi = (data: cancelMem) => {
    return httpService.post("membership/cancel", data)
}

export const companyCodeMembershipApi = (data: codeMem) => {
    return httpService.post("membership/company-code/update", data)
}

export const getMembershipPreLogin = () => {
    return httpService.post("pre-login")
}
// export const getCountryApi = () => {
//     return httpService.post("country")
// }

// export const getStateApi = (id: any) => {
//     return httpService.post("state", id)
// }
interface cPayment {
    user_id: string,
    user_membership_id: string
}
export const confirmPaymentApi = (data: cPayment) => {
    return httpService.post("onboarding/company-code/membership/confirm", data)
}

// ---------------------------------------------------------------------------
// Apply a coupon code (or a received gift card) to the user's active recurring
// membership subscription. The discount lands on the next invoice.
// ---------------------------------------------------------------------------

export type SubscriptionCouponInfo = {
    id: number
    code: string
    name: string
    description: string | null
    type: 'percentage' | 'amount'
    amount: string
    duration: 'once' | 'repeating' | 'forever'
    duration_in_months: number | null
    coupon_type: 'coupon' | 'giftcard'
}

export type SubscriptionInvoicePreview = {
    subtotal_cents: number
    total_before_cents: number
    total_after_cents: number
    savings_cents: number
    currency: string
    next_payment_at: string | null
    period_end_at: string | null
}

export type SubscriptionDiscount = {
    stripe_coupon_id: string
    name: string | null
    label: string
    duration: string
    duration_in_months: number | null
    end_at: string | null
}

export type PreviewCouponResponse = {
    success: boolean
    message?: string
    data?: {
        coupon: SubscriptionCouponInfo
        next_invoice: SubscriptionInvoicePreview
        existing_discount: SubscriptionDiscount | null
        will_replace_existing: boolean
    }
}

export type ApplyCouponResponse = {
    success: boolean
    message?: string
    requires_confirmation?: boolean
    data?: {
        coupon: SubscriptionCouponInfo
        replaced_existing: boolean
    }
}

export type CurrentDiscountResponse = {
    success: boolean
    message?: string
    data?: {
        has_active_subscription: boolean
        discount: SubscriptionDiscount | null
    }
}

export const previewSubscriptionCouponApi = (user_id: number | string, coupon_code: string) => {
    return httpService.post<PreviewCouponResponse>('subscription/coupon/preview', { user_id, coupon_code })
}

export const applySubscriptionCouponApi = (
    user_id: number | string,
    coupon_code: string,
    replace_existing = false
) => {
    return httpService.post<ApplyCouponResponse>('subscription/coupon/apply', {
        user_id,
        coupon_code,
        replace_existing,
    })
}

export const currentSubscriptionDiscountApi = (user_id: number | string) => {
    return httpService.post<CurrentDiscountResponse>('subscription/coupon/current', { user_id })
}
